import { render, staticRenderFns } from "./TablsHalls.vue?vue&type=template&id=432ef41c&"
import script from "./TablsHalls.vue?vue&type=script&lang=js&"
export * from "./TablsHalls.vue?vue&type=script&lang=js&"
import style0 from "./TablsHalls.vue?vue&type=style&index=0&id=432ef41c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports